function clearStaleHeaderLayout() {
  var navBar = jQuery(".site-header .main-navigationbar");
  navBar.removeClass("fixed");
  document.body.style.paddingTop = "";
}

function syncMainContentHeaderOffset() {
  var main = document.getElementById("MainContent");
  if (!main) return;
  if (document.body.classList.contains("index")) {
    main.style.paddingTop = "";
    return;
  }
  var header = document.querySelector(".site-header.header-style-one");
  if (!header) return;
  main.style.paddingTop = header.offsetHeight + "px";
}

function updateHeaderScrolledClass() {
  var header = document.querySelector(".site-header.header-style-one");
  if (!header) return;
  var on = window.scrollY > 100;
  if (header.classList.contains("header-scrolled") === on) return;
  header.classList.toggle("header-scrolled", on);
}

var headerScrollQueued = false;
function queueHeaderScrollHandler() {
  if (headerScrollQueued) return;
  headerScrollQueued = true;
  requestAnimationFrame(function () {
    headerScrollQueued = false;
    updateHeaderScrolledClass();
  });
}

function initSiteHeaderLayout() {
  clearStaleHeaderLayout();
  syncMainContentHeaderOffset();
  updateHeaderScrolledClass();
}

$(document).ready(function () {
  initSiteHeaderLayout();
  requestAnimationFrame(function () {
    syncMainContentHeaderOffset();
  });
  window.addEventListener("scroll", queueHeaderScrollHandler, { passive: true });
});
$(window).on("resize", function () {
  clearStaleHeaderLayout();
  syncMainContentHeaderOffset();
  updateHeaderScrolledClass();
});

function shouldMountBestsellerSlider($el) {
  var $tab = $el.closest(".tab-content");
  if ($tab.length && !$tab.hasClass("active")) return false;
  if ($el.closest(".bestseller-slider-desktop").length) {
    return window.matchMedia && window.matchMedia("(min-width: 768px)").matches;
  }
  if ($el.closest(".top-product-desktop").length) {
    return window.matchMedia && window.matchMedia("(min-width: 768px)").matches;
  }
  return true;
}

function getBestsellerSlickOptions() {
  return {
    autoplay: false,
    slidesToShow: 5,
    speed: 1000,
    slidesToScroll: 1,
    prevArrow: '<button class="slide-arrow slick-prev"><svg viewBox="0 0 10 5"><path transform="translate(10,0) scale(-1,1)" d="M2.37755e-08 2.57132C-3.38931e-06 2.7911 0.178166 2.96928 0.397953 2.96928L8.17233 2.9694L7.23718 3.87785C7.07954 4.031 7.07589 4.28295 7.22903 4.44059C7.38218 4.59824 7.63413 4.60189 7.79177 4.44874L9.43039 2.85691C9.50753 2.78197 9.55105 2.679 9.55105 2.57146C9.55105 2.46392 9.50753 2.36095 9.43039 2.28602L7.79177 0.69418C7.63413 0.541034 7.38218 0.544682 7.22903 0.702329C7.07589 0.859976 7.07954 1.11192 7.23718 1.26507L8.1723 2.17349L0.397965 2.17336C0.178179 2.17336 3.46059e-06 2.35153 2.37755e-08 2.57132Z"></path></svg></button>',
    nextArrow: '<button class="slide-arrow slick-next"><svg viewBox="0 0 10 5"><path d="M2.37755e-08 2.57132C-3.38931e-06 2.7911 0.178166 2.96928 0.397953 2.96928L8.17233 2.9694L7.23718 3.87785C7.07954 4.031 7.07589 4.28295 7.22903 4.44059C7.38218 4.59824 7.63413 4.60189 7.79177 4.44874L9.43039 2.85691C9.50753 2.78197 9.55105 2.679 9.55105 2.57146C9.55105 2.46392 9.50753 2.36095 9.43039 2.28602L7.79177 0.69418C7.63413 0.541034 7.38218 0.544682 7.22903 0.702329C7.07589 0.859976 7.07954 1.11192 7.23718 1.26507L8.1723 2.17349L0.397965 2.17336C0.178179 2.17336 3.46059e-06 2.35153 2.37755e-08 2.57132Z"></path></svg></button>',
    dots: false,
    infinite: false,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 471,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };
}

function initBestsellerProductSliders() {
  if (typeof jQuery === "undefined" || !jQuery.fn.slick) return;
  var $ = jQuery;
  var opts = getBestsellerSlickOptions();
  $(".bestseller-product-slider").each(function () {
    var $el = $(this);
    if ($el.hasClass("slick-initialized")) return;
    if (!$el.find(".bestseller-item, .product-card").length) return;
    if (!shouldMountBestsellerSlider($el)) return;
    $el.slick(opts);
  });
}

function refreshBestsellerProductSliders() {
  initBestsellerProductSliders();
  if (typeof jQuery === "undefined" || !jQuery.fn.slick) return;
  jQuery(".bestseller-product-slider.slick-initialized").each(function () {
    jQuery(this).slick("setPosition");
  });
}

var bestsellerResizeTimer;
$(window).on("resize.bestsellerSlick", function () {
  clearTimeout(bestsellerResizeTimer);
  bestsellerResizeTimer = setTimeout(refreshBestsellerProductSliders, 150);
});

$(document).ready(function() {
    jQuery('.mobile-menu-wrapper').insertAfter('.site-footer');
     countDownIni('.flip-countdown,.js-flip-countdown');
  $(".menu-lnk.has-item").each(function () {
    var $li = $(this);
    var $trigger = $li.children("a.category-btn");
    if (!$trigger.length) {
      $trigger = $li.children("a").first();
    }
    var $dd = $li.find(".menu-dropdown").first();
    if (!$trigger.length || !$dd.length) {
      return;
    }
    var hideTimer;
    function openDesktopMenu() {
      clearTimeout(hideTimer);
      $li.addClass("menu_active");
      $dd.addClass("open_menu");
    }
    function scheduleCloseDesktopMenu() {
      clearTimeout(hideTimer);
      hideTimer = setTimeout(function () {
        $li.removeClass("menu_active");
        $dd.removeClass("open_menu");
      }, 160);
    }
    $trigger.add($dd).on("mouseenter", openDesktopMenu);
    $li.on("mouseleave", scheduleCloseDesktopMenu);
  });
  /*********  size Popup  ********/ 
      $(".size-btn").click(function() { 
        $(".size-popup").toggleClass("active"); 
        $("body").toggleClass("no-scroll");
    });
    $(".close-search").click(function() { 
        $(".size-popup").removeClass("active"); 
        $("body").removeClass("no-scroll");
    });
    $(".close-btn").click(function() { 
        $(".size-popup").removeClass("active"); 
        $("body").removeClass("no-scroll");
    }); 
      /********* Announcebar hide ********/
      $('#announceclose').click(function () {
          $('.announcebar').slideUp();
      }); 
      /********* Mobile Menu ********/ 
      $("#menu").on("click", function () {
          $(".mobile-menu-wrapper, body").toggleClass("active-menu");
      });
      $(".menu-close-icon svg, .mobile-menu-overlay").on("click", function () {
          $(".mobile-menu-wrapper, body").removeClass("active-menu");
      });
       /********* Cart Popup ********/
    if ($('body').hasClass('cart')) {
      // Disable click on the cart-header div
      $('.cart-header').on('click', function(event) {
        event.preventDefault();
        return false;
      });
    }
    else{
    $('.cart-header').on('click', function (e) {
    e.preventDefault();
    setTimeout(function () {
      $('body').addClass('no-scroll cartOpen');
      $('html').addClass('cart-open');
      $('.overlay').addClass('cart_overlay');
    }, 50);
  });
  }
  $('body').on('click', '.overlay.cart_overlay, .closecart', function (e) {
    e.preventDefault();
    $('.overlay').removeClass('cart_overlay');
    $('html').removeClass('cart-open');
    $('body').removeClass('no-scroll cartOpen');
  });


      /********* Mobile Filter Popup ********/
      $('.mobile-facets__open').on('click', function (e) {
        $('body').addClass('mobile-open no-scroll');
        $('.overlay').addClass('active');
      });
      $('body').on('click', '.overlay.active', function (e) {
        if (!$('body').hasClass('mobile-open')) return;
        e.preventDefault();
        e.stopPropagation();
        $('body').removeClass('mobile-open no-scroll overflow-hidden-mobile');
        $('.overlay').removeClass('active');
        var $details = $('.mobile-facets__wrapper .disclosure-has-popup');
        $details.removeClass('menu-opening');
        setTimeout(function () { $details.removeAttr('open'); }, 400);
      });
      $('body').on('click', '.close-filter, .apply-btn, .mobile-facets__footer .btn.no-js-hidden', function (e) {
        e.stopPropagation();
        $('body').removeClass('mobile-open no-scroll overflow-hidden-mobile');
        $('.overlay').removeClass('active');
        var $details = $('.mobile-facets__wrapper .disclosure-has-popup');
        $details.removeClass('menu-opening');
        setTimeout(function () { $details.removeAttr('open'); }, 400);
      });
      $('.filter-title').on('click',function(e){
          e.preventDefault();
          setTimeout(function(){
          $('body').addClass('no-scroll filter-open');
          $('.overlay').addClass('active');
          }, 50);
      }); 
      $('body').on('click','.overlay.active, .close-filter', function(e){
          e.preventDefault(); 
          $('.overlay').removeClass('active');
          $('body').removeClass('no-scroll filter-open');
      });
      /*********  Header Search Popup  ********/ 
      $(".search-header a").click(function() { 
          $(".search-popup").toggleClass("active"); 
          $("body").toggleClass("no-scroll");
          $('.hmuser').removeClass('active');
          $('.hmuser').next().slideUp('fast');
      });
      $(".close-search").click(function() { 
          $(".search-popup").removeClass("active"); 
          $("body").removeClass("no-scroll");
      });
      $(document).on("click", ".search-popup .modal-overlay", function (e) {
        e.preventDefault();
        $(".search-popup").removeClass("active");
        $("body").removeClass("no-scroll");
      });
      /******* Cookie Js *******/
      $('.cookie-close').click(function () {
          $('.cookie').slideUp();
      });
      /******* Subscribe popup Js *******/
        if ($('.subscribe-popup').length > 0) {
        $('.subscribe-popup').addClass('active');
        $('body').addClass('no-scroll');
        $(".subscribe-overlay").addClass("active");
    };
    $('body').on('click', '.subscribe-overlay , .close-sub-btn', function (e) {
        e.preventDefault();
        $("body").removeClass("no-scroll");
        $(".subscribe-overlay").removeClass("active");
        $(".subscribe-popup").removeClass("active");
    });
      // User and Cart Toggle
      $(document).on('click', '.hmuser', function(e) {
          $(this).toggleClass('active');
          $(this).next().slideToggle('fast');
          $(".dropdown-menu").not($(this).next()).slideUp('fast');
      }); 
      /*********  Multi-level accordion nav  ********/ 
      $(document).on('click', '.acnav-label', function (e) {
          var label = $(this);
          var parent = label.parent('.has-children');
          if (!parent.length) return;
          e.preventDefault();
          var list = label.siblings('.acnav-list');
          if (parent.hasClass('is-open')) {
              list.slideUp('fast');
              parent.removeClass('is-open');
          } else {
              list.slideDown('fast');
              parent.addClass('is-open');
          }
      }); 

      /****  TAB JS ****/ 
      $('ul.tabs li').click(function (e) {
          var $this = $(this);
          if ($this.hasClass('active')) {
              e.preventDefault();
              return;
          }
          var $theTab = $this.attr('data-tab');
          $this.closest('.tabs-wrapper').find('ul.tabs li, .tabs-container .tab-content').removeClass('active');
          $('.tabs-container .tab-content[id="'+$theTab+'"], ul.tabs li[data-tab="'+$theTab+'"]').addClass('active');
          setTimeout(function () {
            refreshBestsellerProductSliders();
          }, 50);
      });
 
        if($('.shop-protab-slider').length > 0 ){
            $('.shop-protab-slider').slick({
                rows: 2,
                arrows:false,
                dots: false,
                infinite: false,
                speed: 800,
                slidesToShow: 3,
                slidesToScroll:3, 
                responsive: [
                   {
                      breakpoint: 992,
                      settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2, 
                      }
                    },
                    {
                    breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            arrows:true,
                            prevArrow: '<button class="slide-arrow slick-prev"><svg viewBox="0 0 10 5"><path transform="translate(10,0) scale(-1,1)" d="M2.37755e-08 2.57132C-3.38931e-06 2.7911 0.178166 2.96928 0.397953 2.96928L8.17233 2.9694L7.23718 3.87785C7.07954 4.031 7.07589 4.28295 7.22903 4.44059C7.38218 4.59824 7.63413 4.60189 7.79177 4.44874L9.43039 2.85691C9.50753 2.78197 9.55105 2.679 9.55105 2.57146C9.55105 2.46392 9.50753 2.36095 9.43039 2.28602L7.79177 0.69418C7.63413 0.541034 7.38218 0.544682 7.22903 0.702329C7.07589 0.859976 7.07954 1.11192 7.23718 1.26507L8.1723 2.17349L0.397965 2.17336C0.178179 2.17336 3.46059e-06 2.35153 2.37755e-08 2.57132Z"></path></svg></button>',
                            nextArrow: '<button class="slide-arrow slick-next"><svg viewBox="0 0 10 5"><path d="M2.37755e-08 2.57132C-3.38931e-06 2.7911 0.178166 2.96928 0.397953 2.96928L8.17233 2.9694L7.23718 3.87785C7.07954 4.031 7.07589 4.28295 7.22903 4.44059C7.38218 4.59824 7.63413 4.60189 7.79177 4.44874L9.43039 2.85691C9.50753 2.78197 9.55105 2.679 9.55105 2.57146C9.55105 2.46392 9.50753 2.36095 9.43039 2.28602L7.79177 0.69418C7.63413 0.541034 7.38218 0.544682 7.22903 0.702329C7.07589 0.859976 7.07954 1.11192 7.23718 1.26507L8.1723 2.17349L0.397965 2.17336C0.178179 2.17336 3.46059e-06 2.35153 2.37755e-08 2.57132Z"></path></svg></button>',
                        }
                    } 
                ]
            });
        } 
        /** PDP slider **/
        $('.banner-content-slider').each(function() {
            var $el = $(this);
            var slideCount = parseInt($el.data('slide-count'), 10) || 1;
            $el.slick({
                dots: slideCount > 1,
                infinite: false,
                arrows: false,
                speed: 1000,
                slidesToShow: 1,
                adaptiveHeight: true
            });
        });
        
        if($('.best-product-slider').length > 0 ){
            $('.best-product-slider').slick({
                autoplay: false, 
                slidesToShow: 3,
                speed: 1000,
                slidesToScroll: 3,  
                arrows:false,
                dots: true,
                buttons: false,
                responsive: [ 
                    {
                        breakpoint: 1200,
                        settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2   
                        }
                    },  
                    {
                    breakpoint: 992,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2
                        }
                    },
                    {
                    breakpoint: 576,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1 
                        }
                    }
                ]
            });
        }
         
        if($('.bestsell-cat-slider').length > 0 ){
            $('.bestsell-cat-slider').slick({
                autoplay: false, 
                slidesToShow: 6,
                speed: 1000,
                slidesToScroll: 6,  
                prevArrow: '<button class="slide-arrow slick-prev"><svg viewBox="0 0 10 5"><path transform="translate(10,0) scale(-1,1)" d="M2.37755e-08 2.57132C-3.38931e-06 2.7911 0.178166 2.96928 0.397953 2.96928L8.17233 2.9694L7.23718 3.87785C7.07954 4.031 7.07589 4.28295 7.22903 4.44059C7.38218 4.59824 7.63413 4.60189 7.79177 4.44874L9.43039 2.85691C9.50753 2.78197 9.55105 2.679 9.55105 2.57146C9.55105 2.46392 9.50753 2.36095 9.43039 2.28602L7.79177 0.69418C7.63413 0.541034 7.38218 0.544682 7.22903 0.702329C7.07589 0.859976 7.07954 1.11192 7.23718 1.26507L8.1723 2.17349L0.397965 2.17336C0.178179 2.17336 3.46059e-06 2.35153 2.37755e-08 2.57132Z"></path></svg></button>',
                nextArrow: '<button class="slide-arrow slick-next"><svg viewBox="0 0 10 5"><path d="M2.37755e-08 2.57132C-3.38931e-06 2.7911 0.178166 2.96928 0.397953 2.96928L8.17233 2.9694L7.23718 3.87785C7.07954 4.031 7.07589 4.28295 7.22903 4.44059C7.38218 4.59824 7.63413 4.60189 7.79177 4.44874L9.43039 2.85691C9.50753 2.78197 9.55105 2.679 9.55105 2.57146C9.55105 2.46392 9.50753 2.36095 9.43039 2.28602L7.79177 0.69418C7.63413 0.541034 7.38218 0.544682 7.22903 0.702329C7.07589 0.859976 7.07954 1.11192 7.23718 1.26507L8.1723 2.17349L0.397965 2.17336C0.178179 2.17336 3.46059e-06 2.35153 2.37755e-08 2.57132Z"></path></svg></button>',
                dots: false,
                buttons: false,
                responsive: [ 
                    {
                        breakpoint: 1400,
                        settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4   
                        }
                    },  
                    {
                    breakpoint: 992,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3 
                        }
                    },
                    {
                    breakpoint: 576,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1 
                        }
                    }
                ]
            });
        }

        initBestsellerProductSliders();
        $(window).on("load", function () {
          refreshBestsellerProductSliders();
        });

        if($('.review-slider').length > 0 ){
            $('.review-slider').slick({
                autoplay: false, 
                slidesToShow: 4,
                speed: 1000,
                slidesToScroll: 4,  
                prevArrow: '<button class="slide-arrow slick-prev"><svg viewBox="0 0 10 5"><path transform="translate(10,0) scale(-1,1)" d="M2.37755e-08 2.57132C-3.38931e-06 2.7911 0.178166 2.96928 0.397953 2.96928L8.17233 2.9694L7.23718 3.87785C7.07954 4.031 7.07589 4.28295 7.22903 4.44059C7.38218 4.59824 7.63413 4.60189 7.79177 4.44874L9.43039 2.85691C9.50753 2.78197 9.55105 2.679 9.55105 2.57146C9.55105 2.46392 9.50753 2.36095 9.43039 2.28602L7.79177 0.69418C7.63413 0.541034 7.38218 0.544682 7.22903 0.702329C7.07589 0.859976 7.07954 1.11192 7.23718 1.26507L8.1723 2.17349L0.397965 2.17336C0.178179 2.17336 3.46059e-06 2.35153 2.37755e-08 2.57132Z"></path></svg></button>',
                nextArrow: '<button class="slide-arrow slick-next"><svg viewBox="0 0 10 5"><path d="M2.37755e-08 2.57132C-3.38931e-06 2.7911 0.178166 2.96928 0.397953 2.96928L8.17233 2.9694L7.23718 3.87785C7.07954 4.031 7.07589 4.28295 7.22903 4.44059C7.38218 4.59824 7.63413 4.60189 7.79177 4.44874L9.43039 2.85691C9.50753 2.78197 9.55105 2.679 9.55105 2.57146C9.55105 2.46392 9.50753 2.36095 9.43039 2.28602L7.79177 0.69418C7.63413 0.541034 7.38218 0.544682 7.22903 0.702329C7.07589 0.859976 7.07954 1.11192 7.23718 1.26507L8.1723 2.17349L0.397965 2.17336C0.178179 2.17336 3.46059e-06 2.35153 2.37755e-08 2.57132Z"></path></svg></button>',
                dots: false,
                buttons: false,
                responsive: [ 
                    {
                    breakpoint: 991,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2, 
                        }
                    },
                    {
                    breakpoint: 768,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2, 
                        }
                    },
                    {
                    breakpoint: 640,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1, 
                        }
                    }
                ]
            });
        }
        
        if($('.poster-slider-1').length > 0 ){
            $('.poster-slider-1').slick({
                autoplay: false, 
                slidesToShow: 4,
                speed: 1000,
                slidesToScroll: 4,  
                arrows:true,
                prevArrow: '<button class="slide-arrow slick-prev"><svg viewBox="0 0 10 5"><path transform="translate(10,0) scale(-1,1)" d="M2.37755e-08 2.57132C-3.38931e-06 2.7911 0.178166 2.96928 0.397953 2.96928L8.17233 2.9694L7.23718 3.87785C7.07954 4.031 7.07589 4.28295 7.22903 4.44059C7.38218 4.59824 7.63413 4.60189 7.79177 4.44874L9.43039 2.85691C9.50753 2.78197 9.55105 2.679 9.55105 2.57146C9.55105 2.46392 9.50753 2.36095 9.43039 2.28602L7.79177 0.69418C7.63413 0.541034 7.38218 0.544682 7.22903 0.702329C7.07589 0.859976 7.07954 1.11192 7.23718 1.26507L8.1723 2.17349L0.397965 2.17336C0.178179 2.17336 3.46059e-06 2.35153 2.37755e-08 2.57132Z"></path></svg></button>',
                nextArrow: '<button class="slide-arrow slick-next"><svg viewBox="0 0 10 5"><path d="M2.37755e-08 2.57132C-3.38931e-06 2.7911 0.178166 2.96928 0.397953 2.96928L8.17233 2.9694L7.23718 3.87785C7.07954 4.031 7.07589 4.28295 7.22903 4.44059C7.38218 4.59824 7.63413 4.60189 7.79177 4.44874L9.43039 2.85691C9.50753 2.78197 9.55105 2.679 9.55105 2.57146C9.55105 2.46392 9.50753 2.36095 9.43039 2.28602L7.79177 0.69418C7.63413 0.541034 7.38218 0.544682 7.22903 0.702329C7.07589 0.859976 7.07954 1.11192 7.23718 1.26507L8.1723 2.17349L0.397965 2.17336C0.178179 2.17336 3.46059e-06 2.35153 2.37755e-08 2.57132Z"></path></svg></button>',
                dots: false,
                buttons: false,
                responsive: [ 
                    {
                    breakpoint: 1200,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3   
                        }
                    },  
                    {
                    breakpoint: 768,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2 
                        }
                    },
                    {
                    breakpoint: 576,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1 
                        }
                    }
                ]
            });
        }

        if ($('.latest-article-slider').length > 0) {
        $('.latest-article-slider').slick({
            prevArrow: '<button class="slide-arrow slick-prev"><svg viewBox="0 0 10 5"><path transform="translate(10,0) scale(-1,1)" d="M2.37755e-08 2.57132C-3.38931e-06 2.7911 0.178166 2.96928 0.397953 2.96928L8.17233 2.9694L7.23718 3.87785C7.07954 4.031 7.07589 4.28295 7.22903 4.44059C7.38218 4.59824 7.63413 4.60189 7.79177 4.44874L9.43039 2.85691C9.50753 2.78197 9.55105 2.679 9.55105 2.57146C9.55105 2.46392 9.50753 2.36095 9.43039 2.28602L7.79177 0.69418C7.63413 0.541034 7.38218 0.544682 7.22903 0.702329C7.07589 0.859976 7.07954 1.11192 7.23718 1.26507L8.1723 2.17349L0.397965 2.17336C0.178179 2.17336 3.46059e-06 2.35153 2.37755e-08 2.57132Z"></path></svg></button>',
            nextArrow: '<button class="slide-arrow slick-next"><svg viewBox="0 0 10 5"><path d="M2.37755e-08 2.57132C-3.38931e-06 2.7911 0.178166 2.96928 0.397953 2.96928L8.17233 2.9694L7.23718 3.87785C7.07954 4.031 7.07589 4.28295 7.22903 4.44059C7.38218 4.59824 7.63413 4.60189 7.79177 4.44874L9.43039 2.85691C9.50753 2.78197 9.55105 2.679 9.55105 2.57146C9.55105 2.46392 9.50753 2.36095 9.43039 2.28602L7.79177 0.69418C7.63413 0.541034 7.38218 0.544682 7.22903 0.702329C7.07589 0.859976 7.07954 1.11192 7.23718 1.26507L8.1723 2.17349L0.397965 2.17336C0.178179 2.17336 3.46059e-06 2.35153 2.37755e-08 2.57132Z"></path></svg></button>',
            dots: false,
            infinite: true, 
            speed: 800,
            slidesToShow: 3,
            slidesToScroll: 3,  
            responsive: [ 
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                breakpoint: 576,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1 
                    }
                }
            ]
        });
        }

        /** PDP slider **/
        window.pdpSyncThumbHighlight = function (idx) {
            var $thumb = $('.pdp-thumb-slider');
            if (!$thumb.length || typeof idx !== 'number' || isNaN(idx)) return;
            $thumb.find('.pdp-thumb-slider-itm').removeClass('pdp-thumb--current');
            $thumb.find('.pdp-thumb-slider-itm[data-slide-idx="' + idx + '"]').addClass('pdp-thumb--current');
        };
        function initPdpGallerySliders() {
            if (typeof jQuery === 'undefined' || typeof jQuery.fn.slick === 'undefined') return;
            var $ = jQuery;
            var $main = $('.pdp-main-slider');
            var $thumb = $('.pdp-thumb-slider');
            if (!$main.length) return;
            if ($main.hasClass('slick-initialized')) return;
            var initialSlide = 0;
            var rawInitial = $main.attr('data-initial-slide');
            if (rawInitial !== undefined && rawInitial !== '') {
                var parsedInitial = parseInt(rawInitial, 10);
                if (!isNaN(parsedInitial) && parsedInitial >= 0) {
                    initialSlide = parsedInitial;
                }
            }
            if ($thumb.length && !$thumb.hasClass('slick-initialized')) {
                $thumb.slick({
            prevArrow: '<button class="slide-arrow slick-prev"><svg viewBox="0 0 10 5"><path transform="translate(10,0) scale(-1,1)" d="M2.37755e-08 2.57132C-3.38931e-06 2.7911 0.178166 2.96928 0.397953 2.96928L8.17233 2.9694L7.23718 3.87785C7.07954 4.031 7.07589 4.28295 7.22903 4.44059C7.38218 4.59824 7.63413 4.60189 7.79177 4.44874L9.43039 2.85691C9.50753 2.78197 9.55105 2.679 9.55105 2.57146C9.55105 2.46392 9.50753 2.36095 9.43039 2.28602L7.79177 0.69418C7.63413 0.541034 7.38218 0.544682 7.22903 0.702329C7.07589 0.859976 7.07954 1.11192 7.23718 1.26507L8.1723 2.17349L0.397965 2.17336C0.178179 2.17336 3.46059e-06 2.35153 2.37755e-08 2.57132Z"></path></svg></button>',
            nextArrow: '<button class="slide-arrow slick-next"><svg viewBox="0 0 10 5"><path d="M2.37755e-08 2.57132C-3.38931e-06 2.7911 0.178166 2.96928 0.397953 2.96928L8.17233 2.9694L7.23718 3.87785C7.07954 4.031 7.07589 4.28295 7.22903 4.44059C7.38218 4.59824 7.63413 4.60189 7.79177 4.44874L9.43039 2.85691C9.50753 2.78197 9.55105 2.679 9.55105 2.57146C9.55105 2.46392 9.50753 2.36095 9.43039 2.28602L7.79177 0.69418C7.63413 0.541034 7.38218 0.544682 7.22903 0.702329C7.07589 0.859976 7.07954 1.11192 7.23718 1.26507L8.1723 2.17349L0.397965 2.17336C0.178179 2.17336 3.46059e-06 2.35153 2.37755e-08 2.57132Z"></path></svg></button>',
            dots: false,
            speed: 1000, 
            slidesToScroll: 1,
            touchMove: true,
            arrows: false,  
            focusOnSelect: false,
            infinite: true,
            vertical: true,
            verticalSwiping: true,
            slidesToShow: 5,
            initialSlide: 0,
            responsive: [{
                breakpoint: 1261,
                    settings: {
                        slidesToShow: 3 
                    }
                },
                {
                breakpoint: 992,
                    settings: {
                        slidesToShow: 5,
                    }
                },
                {
                breakpoint: 576,
                    settings: {
                        vertical: false,
                        verticalSwiping: false,
                        slidesToShow: 4 
                    }
                }
            ]   
                });
            }
            if (!$main.hasClass('slick-initialized')) {
            $main.slick({
            dots: false,
            infinite: true,
            speed: 1000,
            vertical: false,
            slidesToShow: 1,
            initialSlide: initialSlide,
            arrows: false
        });
            }
            if ($main.hasClass('slick-initialized')) {
            $main.off('afterChange.pdpGallery').on('afterChange.pdpGallery', function (e, slick, currentSlide) {
                window.pdpSyncThumbHighlight(slick.currentSlide);
            });
            if ($thumb.length) {
                $thumb.off('click.pdpThumbSelect').on('click.pdpThumbSelect', '.pdp-thumb-slider-itm', function () {
                    var idx = parseInt($(this).attr('data-slide-idx'), 10);
                    if (!isNaN(idx) && $main.hasClass('slick-initialized')) {
                        $main.slick('slickGoTo', idx);
                        window.pdpSyncThumbHighlight(idx);
                    }
                });
            }
            setTimeout(function () {
                window.pdpSyncThumbHighlight(initialSlide);
            }, 50);
            }
        }
        function schedulePdpGalleryInit() {
            var attempts = 0;
            var maxTries = 60;
            function tick() {
                if (!jQuery('.pdp-main-slider').length) return;
                attempts++;
                if (typeof jQuery !== 'undefined' && jQuery.fn.slick) {
                    initPdpGallerySliders();
                }
                if (jQuery('.pdp-main-slider').length && !jQuery('.pdp-main-slider').hasClass('slick-initialized') && attempts < maxTries) {
                    setTimeout(tick, 50);
                }
            }
            tick();
        }
        schedulePdpGalleryInit();
        $(window).on('load', function () {
            initPdpGallerySliders();
            if (typeof jQuery === 'undefined' || typeof jQuery.fn.slick === 'undefined') return;
            var $m = $('.pdp-main-slider.slick-initialized');
            var $t = $('.pdp-thumb-slider.slick-initialized');
            if ($m.length) $m.slick('setPosition');
            if ($t.length) $t.slick('setPosition');
        });
        var pdpSliderResizeTimer;
        $(window).on('resize orientationchange', function () {
            if (!$('.pdp-main-slider').length) return;
            clearTimeout(pdpSliderResizeTimer);
            pdpSliderResizeTimer = setTimeout(function () {
                if (typeof $.fn.slick === 'undefined') return;
                var $m = $('.pdp-main-slider.slick-initialized');
                var $t = $('.pdp-thumb-slider.slick-initialized');
                if ($m.length) $m.slick('setPosition');
                if ($t.length) $t.slick('setPosition');
            }, 150);
        });
        // product slider zoom
    $('.pdp-main-img.zoom').each(function() {
      $(this).zoom({
        url: false,
        callback: false,
        target: false,
        duration: 120,
        on: 'mouseover', // other options: grab, click, toggle
        touch: true, // enables a touch fallback
        onZoomIn: false,
        onZoomOut: false,
        magnify: 1
      });
    });
       // Slick lightbox 
    if($('.lightbox').length>0) {
        $('.lightbox').slickLightbox({
           itemSelector: 'a.open-lightbox',
           caption: 'caption',
           prevArrow: '<button class="slide-arrow slick-prev"><svg viewBox="0 0 10 5"><path transform="translate(10,0) scale(-1,1)" d="M2.37755e-08 2.57132C-3.38931e-06 2.7911 0.178166 2.96928 0.397953 2.96928L8.17233 2.9694L7.23718 3.87785C7.07954 4.031 7.07589 4.28295 7.22903 4.44059C7.38218 4.59824 7.63413 4.60189 7.79177 4.44874L9.43039 2.85691C9.50753 2.78197 9.55105 2.679 9.55105 2.57146C9.55105 2.46392 9.50753 2.36095 9.43039 2.28602L7.79177 0.69418C7.63413 0.541034 7.38218 0.544682 7.22903 0.702329C7.07589 0.859976 7.07954 1.11192 7.23718 1.26507L8.1723 2.17349L0.397965 2.17336C0.178179 2.17336 3.46059e-06 2.35153 2.37755e-08 2.57132Z"></path></svg></button>',
           nextArrow: '<button class="slide-arrow slick-next"><svg viewBox="0 0 10 5"><path d="M2.37755e-08 2.57132C-3.38931e-06 2.7911 0.178166 2.96928 0.397953 2.96928L8.17233 2.9694L7.23718 3.87785C7.07954 4.031 7.07589 4.28295 7.22903 4.44059C7.38218 4.59824 7.63413 4.60189 7.79177 4.44874L9.43039 2.85691C9.50753 2.78197 9.55105 2.679 9.55105 2.57146C9.55105 2.46392 9.50753 2.36095 9.43039 2.28602L7.79177 0.69418C7.63413 0.541034 7.38218 0.544682 7.22903 0.702329C7.07589 0.859976 7.07954 1.11192 7.23718 1.26507L8.1723 2.17349L0.397965 2.17336C0.178179 2.17336 3.46059e-06 2.35153 2.37755e-08 2.57132Z"></path></svg></button>',
           navigateByKeyboard: true,
           layouts: {
              closeButton: '<button class="close"><svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50" fill="none"><path d="M27.7618 25.0008L49.4275 3.33503C50.1903 2.57224 50.1903 1.33552 49.4275 0.572826C48.6647 -0.189868 47.428 -0.189965 46.6653 0.572826L24.9995 22.2386L3.33381 0.572826C2.57102 -0.189965 1.3343 -0.189965 0.571605 0.572826C-0.191089 1.33562 -0.191186 2.57233 0.571605 3.33503L22.2373 25.0007L0.571605 46.6665C-0.191186 47.4293 -0.191186 48.666 0.571605 49.4287C0.952952 49.81 1.45285 50.0007 1.95275 50.0007C2.45266 50.0007 2.95246 49.81 3.3339 49.4287L24.9995 27.763L46.6652 49.4287C47.0465 49.81 47.5464 50.0007 48.0463 50.0007C48.5462 50.0007 49.046 49.81 49.4275 49.4287C50.1903 48.6659 50.1903 47.4292 49.4275 46.6665L27.7618 25.0008Z" fill="white"></path></svg></button>'
           }
        });
      
      $(".pdp-main-img").click(function() {
        if($('a.pdp-main-img').hasClass('open-lightbox')){
          $('body').addClass('no-scroll');
        }else{
          $('body').removeClass('no-scroll');
        }
      });
      $('body').on('click', '.slick-lightbox-inner .close, .slick-lightbox-hide', function() {
        $('body').removeClass('no-scroll');
      });
    }
      function responsiveMenu(){
        if(jQuery(window).width() < 768) {
          $('.product-filter-column').prependTo('.product-heading-row');
        }
        else { 
          $('.product-filter-column').prependTo('.product-list-row');
          if($('body').hasClass('mobile-open') ){
            $('body').removeClass('mobile-open no-scroll overflow-hidden-mobile');
            $('.overlay').removeClass('active');
           }
        }

           if(jQuery(window).width() < 768) {
             if(!$('.mobile-lag').length > 0 ){
              const newDiv = document.createElement('div');
              newDiv.className = 'mobile-lag d-flex aling-item-center';
              $(newDiv).insertAfter('.menu-close-icon');
              $('.languages , .currency').prependTo('.mobile-lag');
            }else{
               return false;
            }
          }
          else {
            $('.languages, .currency').appendTo('.announcebar-right > ul');
            $('.mobile-lag').remove();
          }
      }
      jQuery(document).ready(function() {
        responsiveMenu();
      });
      
      jQuery(window).resize(function() {
        responsiveMenu();
      });

      // currency-nice-select
  
    $('body').on('click', '.country-name .nice-select', function (e) {
      e.stopPropagation(); // Stop the event from propagating to the body
      $(this).toggleClass('open');
    });
    $('body').on('click', function (e) {
      $('.country-name .nice-select').removeClass('open');
    });
    
    function currencyFormSubmit(event) {
      event.target.form.submit();
    }
    
    document.querySelectorAll('.country-name .nice-select .list li').forEach(function (currencyItem) {
      currencyItem.addEventListener('click', function () {
        // Trigger change event on the associated select element
        var selectElement = this.closest('.country-name').querySelector('select');
        if (selectElement) {
          // Set the selected option based on the data-currency attribute of the clicked li
          selectElement.value = this.dataset.currency;
          
          // Trigger change event
          var event = new Event('change', { bubbles: true });
          selectElement.dispatchEvent(event);
    
          // Submit the form
          currencyFormSubmit({ target: selectElement });
        }
      });
    });
        // coupan code
  $('body').on('keyup','.discount_coupan', function() {
   var apply_href = $('.apply').attr("href").split('discount=')[0];
   var val = $(this).val();
    $('.apply').attr("href",apply_href+'discount='+val);
  });

  // notify me
  $('body').on('click','.notify-btn', function(e) {
      e.preventDefault();
      $('body').addClass('no-scroll notify-active');
      $('.out-of-stock-form,.overlay').addClass('active');
    });
   $('body').on('click','.overlay,.notify-popup-close', function(e) {
      e.preventDefault();
     $('body').removeClass('no-scroll notify-active');
      $('.out-of-stock-form,.overlay').removeClass('active');
    });
     

 // quickview
  $('body').on('click', '.quickview-close', function(e) {
    e.preventDefault();
    $('.quickview-popup').hide();
    $('body').removeClass('no-scroll quick-active');
  });
  
  $('body').on('click', '.quickview-btn', function(e) {
    e.preventDefault();
    $('body').addClass('no-scroll quick-active');
    var href= '/products/'+$(this).find('a').data('handle')+'?view=qv';
    $.get(href, function(product) {
      $('.quickview_popup_data').html(product);
      $('.qv_slider').slick({
          autoplay: false,
          slidesToShow: 1,
          speed: 1000,
          slidesToScroll: 1,
          arrows: true,
       prevArrow: '<button class="slide-arrow slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="4" height="6" viewBox="0 0 4 6" fill="none"><path transform="translate(4,0) scale(-1,1)" fill-rule="evenodd" clip-rule="evenodd" d="M0.65976 0.662719C0.446746 0.879677 0.446746 1.23143 0.65976 1.44839L2.18316 3L0.65976 4.55161C0.446747 4.76856 0.446747 5.12032 0.65976 5.33728C0.872773 5.55424 1.21814 5.55424 1.43115 5.33728L3.34024 3.39284C3.55325 3.17588 3.55325 2.82412 3.34024 2.60716L1.43115 0.662719C1.21814 0.445761 0.872773 0.445761 0.65976 0.662719Z" fill="white"></path></svg></button>',
          nextArrow: '<button class="slide-arrow slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="4" height="6" viewBox="0 0 4 6" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.65976 0.662719C0.446746 0.879677 0.446746 1.23143 0.65976 1.44839L2.18316 3L0.65976 4.55161C0.446747 4.76856 0.446747 5.12032 0.65976 5.33728C0.872773 5.55424 1.21814 5.55424 1.43115 5.33728L3.34024 3.39284C3.55325 3.17588 3.55325 2.82412 3.34024 2.60716L1.43115 0.662719C1.21814 0.445761 0.872773 0.445761 0.65976 0.662719Z" fill="white"></path></svg></button>',
          dots: false,
          buttons: false,
          infinite: false,
          loop: false
      });

    });
    $('.quickview-popup').show();
  });

 $('body').on('change', '.quickview_popup_data .new-swatch .button', function() {
    var $swatch = $(this).parents('.new-swatch');
    $swatch.find('label.color-swatch').removeClass('active');
    $(this).find('input:checked').siblings('label').addClass('active');
    var data_val = $(this).children('input:checked').val();
    $swatch.find('.option-label').text(data_val);
   
    var selectedValues = [];

//     // Collect selected option values
    $('.quickview_popup_data .new-swatch .button input:checked').each(function() {
    var selectedValue = $(this).val();
    if (selectedValue) {
      selectedValues.push(selectedValue);
    }
  });

var joinedValues = selectedValues.join(' / ');
  
    $('.variant-qv').each(function() {
      
     var variant_title = $(this).data('title'); 
     var variant_img = $('.variant-qv[data-title="'+variant_title+'"]').data('img');
     var variant_price = $('.variant-qv[data-title="'+variant_title+'"]').data('price');
     var qv_btn =  $('.variant-qv[data-title="'+variant_title+'"]').data('avail');
     var variant_id = $('.variant-qv[data-title="'+variant_title+'"]').data('id');
      variant_title = String(variant_title);
      joinedValues = String(joinedValues);
      
      if(variant_title === joinedValues){
        
      var slideIndex = $('.qv_slider .qv-pro-slider-img img[data-img="'+variant_img+'"]').parent().index();
      $('.qv_slider').slick('slickGoTo', slideIndex)
        
        $('.qv-price').find('.price-item--regular').text(variant_price);

        if(qv_btn === true || qv_btn === 'true' || qv_btn === 1){
          $('#quick-view-temp .product-form__submit').find('span').text('Add to Cart');
          $('#quick-view-temp .product-form__submit').removeAttr('disabled');
        }else{
          $('#quick-view-temp .product-form__submit').find('span').text('Sold out');
          $('#quick-view-temp .product-form__submit').attr('disabled', 'disabled');
        }

        $('input[name="id"]').val(variant_id);
        
      }
  });
  
  });
  
// end quickview
   // sticky addtocart button

if($('body').hasClass('template-product')){
$.fn.isInViewport = function() {
    var elementTop = this.offset().top;
    var elementBottom = elementTop + this.outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
};

    $(window).scroll(function() {
        if ($('.cart-btn.product-button').isInViewport()) {
          $('.products-add-cart-sticky').removeClass('show-btn');
        } else {
          $('.products-add-cart-sticky').addClass('show-btn');
        }
    });
    }

   $(".stickyOpt.nice-select").on('click', function(){
		$(this).toggleClass('open');
    });
    $(".stickyOpt .vrOpt").on('click', function(e){
        var sectionId = $('.product-page-first-section').attr('data-section-id');
		var number = $(this).data('no');
        $(".stickyOpt .selectedOpt").html($(this).html());
      	$(this).toggleClass('open');
      	this.productvariants = JSON.parse(document.getElementById('variants'+sectionId).innerHTML);
        var stOpt = this.productvariants[number],
            o1 = stOpt.option1, o2 = stOpt.option2, o3 = stOpt.option3;
        $('.stickCtImg').attr('src', stOpt.featured_image.src+'&width=100');
        if($('select.single-option-selector').length){
        } else {
            if(o2 != null){var stOpt2 = o2.replace(/'/g, "\\'");$(".swatchInput[value='"+stOpt2+"']").prop("checked",true)}
            if(o3 != null){var stOpt3 = o3.replace(/'/g, "\\'");$(".swatchInput[value='"+stOpt3+"']").prop("checked",true)}
            if(o1 != null){var stOpt1 = o1.replace(/'/g, "\\'");$(".swatchInput[value='"+stOpt1+"']").trigger('click')}
        }
    });
  
      $(".stickyQty .quantity__button").on("click", function(){
      var qtyField = $('.mianQty'),oldValue = $(qtyField).val(),newVal = 1;
      if ($(this).is(".quantity-increment")) {
        newVal = parseInt(oldValue) + 1;
      } else if (oldValue > 1) {
        newVal = parseInt(oldValue) - 1;
      }
      $(qtyField).val(newVal).trigger('change');
    });
    $('.mianQty').on("change", function(){
      $('#stquantity').val($(this).val());
    });
// end sticky 

   // custom reviews on product page
  $(window).on('load', function() {
    $(".pdp-right-column").find(".jdgm-prev-badge").append("<a class='product-write-review d-flex align-items-center'><svg xmlns='http://www.w3.org/2000/svg' fill='#00000' id='Outline' viewBox='0 0 24 24' width='16' height='16'><path d='M22.853,1.148a3.626,3.626,0,0,0-5.124,0L1.465,17.412A4.968,4.968,0,0,0,0,20.947V23a1,1,0,0,0,1,1H3.053a4.966,4.966,0,0,0,3.535-1.464L22.853,6.271A3.626,3.626,0,0,0,22.853,1.148ZM5.174,21.122A3.022,3.022,0,0,1,3.053,22H2V20.947a2.98,2.98,0,0,1,.879-2.121L15.222,6.483l2.3,2.3ZM21.438,4.857,18.932,7.364l-2.3-2.295,2.507-2.507a1.623,1.623,0,1,1,2.295,2.3Z'></path></svg> Write a Review</a>");
  });
  
});
    
   
if ($(".my-acc-column").length > 0) {
jQuery(function ($) {
    var topMenuHeight = $("#daccount-nav").outerHeight();
    $("#account-nav").menuScroll(topMenuHeight);
    $(".account-list li:first-child").addClass("active");
});
// COPY THE FOLLOWING FUNCTION INTO ANY SCRIPTS
jQuery.fn.extend({
    menuScroll: function (offset) {
        // Declare all global variables
        var topMenu = this;
        var topOffset = offset ? offset : 0;
        var menuItems = $(topMenu).find("a");
        var lastId;
        // Save all menu items into scrollItems array
        var scrollItems = $(menuItems).map(function () {
            var item = $($(this).attr("href"));
            if (item.length) {
                return item;
            }
        });
        // When the menu item is clicked, get the #id from the href value, then scroll to the #id element
        $(topMenu).on("click", "a", function (e) {
            var href = $(this).attr("href");
            var offsetTop = href === "#" ? 0 : $(href).offset().top - topOffset;
            function checkWidth() {
                var windowSize = $(window).width();
                if (windowSize <= 767) {
                    $('html, body').stop().animate({
                        scrollTop: offsetTop - 200
                    }, 300);
                }
                else {
                    $('html, body').stop().animate({
                        scrollTop: offsetTop - 100
                    }, 300);
                }
            }
            // Execute on load
            checkWidth();
            // Bind event listener
            $(window).resize(checkWidth);
            e.preventDefault();
        });
        // When page is scrolled
        $(window).scroll(function () {
            function checkWidth() {
                var windowSize = $(window).width();
                if (windowSize <= 767) {
                    var nm = $("html").scrollTop();
                    var nw = $("body").scrollTop();
                    var fromTop = (nm > nw ? nm : nw) + topOffset;
                    // When the page pass one #id section, return all passed sections to scrollItems and save them into new array current
                    var current = $(scrollItems).map(function () {
                        if ($(this).offset().top - 250 <= fromTop)
                            return this;
                    });
                    // Get the most recent passed section from current array
                    current = current[current.length - 1];
                    var id = current && current.length ? current[0].id : "";
                    if (lastId !== id) {
                        lastId = id;
                        // Set/remove active class
                        $(menuItems)
                            .parent().removeClass("active")
                            .end().filter("[href='#" + id + "']").parent().addClass("active");
                    }
                }
                else {
                    var nm = $("html").scrollTop();
                    var nw = $("body").scrollTop();
                    var fromTop = (nm > nw ? nm : nw) + topOffset;
                    // When the page pass one #id section, return all passed sections to scrollItems and save them into new array current
                    var current = $(scrollItems).map(function () {
                        if ($(this).offset().top <= fromTop)
                            return this;
                    });
                    // Get the most recent passed section from current array
                    current = current[current.length - 1];
                    var id = current && current.length ? current[0].id : "";
                    if (lastId !== id) {
                        lastId = id;
                        // Set/remove active class
                        $(menuItems)
                            .parent().removeClass("active")
                            .end().filter("[href='#" + id + "']").parent().addClass("active");
                    }
                }
            }
            // Execute on load
            checkWidth();
            // Bind event listener
            $(window).resize(checkWidth);
        });
    }
});
}
function countDownIni(countdown) {
  $(countdown).each(function () {
    var countdown = $(this);
    var promoperiod;
    if (countdown.attr('data-promoperiod')) {
      promoperiod = new Date().getTime() + parseInt(countdown.attr('data-promoperiod'), 10);
    } else if (countdown.attr('data-countdown')) {
      promoperiod = countdown.attr('data-countdown');
    }
    if (Date.parse(promoperiod) - Date.parse(new Date()) > 0) {
      $(this).addClass('countdown-block');
      countdown.countdown(promoperiod, function (event) {
        // countdown.html(event.strftime('%-w weeks %-d days %Hh %Mm %Ss'));
        countdown.html(event.strftime('<span><span>%D</span><span class="dots"> : </span></span>' + '<span><span>%H</span><span class="dots"> : </span></span>' + '<span><span>%M</span><span class="dots"> : </span></span>' + '<span><span class="second">%S</span></span>'));
      });
    }
    if (Date.parse(promoperiod) - Date.parse(new Date()) < 0) {
        $(this).parent().css('display','none');
     }
  });
}